import React from "react";
import { Provider } from "react-redux";
import { store } from "shared/store";
import GivingButtonV2 from "shared/components/giving-form-v2/App/GivingButtonV2";
import MixpanelService from "shared/services/MixpanelService";

export default class GivingButton extends React.Component {
  render() {
    const {
      buttonText,
      buttonConfig,
      campaign,
      externalGiveLink,
      entityId,
      entityFeaturesEnabled,
      fromMenuBar,
    } = this.props;

    const isCampaignPage =
      window.location.href.includes("/campaigns/") ||
      buttonConfig == "per campaign status";

    const trackGiveButtonEvent = () => {
      if (typeof window.EventAnalyticsService != "undefined") {
        window.EventAnalyticsService.addEvent({
          name: "GIVING FORM - GIVE BUTTON",
          component_type: "MenuBar",
          component_subtype: "GivingDay",
        });
      }
      MixpanelService.trackGivingButtonClick(campaign.name);
    };
    // campaign page + closed / pending / staging
    if (
      isCampaignPage &&
      (campaign.status == "closed" ||
        campaign.status == "pending" ||
        campaign.status == "staging")
    ) {
      return null;
    } else if (
      (isCampaignPage && campaign.external_donation_url) ||
      buttonConfig === "external"
    ) {
      // campaign page + external giving button || main page + external
      return (
        <a
          data-testid="t-MenuBar-GivingD--GivingB-a"
          className={`btn btn-primary m-sm-r giving-nav-giving-btn ${isCampaignPage ? "" : "primary-color-background"}`}
          href={isCampaignPage ? campaign.external_donation_url : externalGiveLink}
          onClick={trackGiveButtonEvent}>
          {buttonText || "GIVE"}
        </a>
      );
    } else if (isCampaignPage || buttonConfig == "launch") {
      // campaign page || main page + launch
      return (
        <Provider store={store}>
          <GivingButtonV2
            entityFeaturesEnabled={entityFeaturesEnabled}
            fromMenuBar={fromMenuBar}
            entityId={entityId}
            campaign={campaign}
            buttonText={buttonText}
          />
        </Provider>
      );
    }
    return (
      <div style={{ display: "none" }}>
        <Provider store={store}>
          <GivingButtonV2
            entityFeaturesEnabled={entityFeaturesEnabled}
            fromMenuBar={fromMenuBar}
            buttonText={buttonText}
            entityId={entityId}
          />
        </Provider>
      </div>
    );
  }
}
